import * as React from 'react';

import { Tooltip as RadixTooltip } from '@radix-ui/themes';
import type { RadixTooltipProps } from '@/types/radix-ui';

export type TooltipProps = RadixTooltipProps;

/**
 * Tooltip — simple wrapper for Radix Themes Tooltip. In the future, this component will be extended and adapted for the project design system.
 */
export const Tooltip: React.FC<TooltipProps> = props => {
  return <RadixTooltip {...props} />;
};
